// Replaces the legal-document-publishing calls that used to live in CourierConfigService.js
// (getCourierLegalCurrent / getCourierLegalVersions / publishCourierLegalVersion), which hit
// /courier/legal-documents/* on a courier-role-gated route that no longer exists — that whole
// file/page was deleted along with the courier package.
//
// New backend routes (com.axium.legal.LegalController, axium-backend):
//   GET  /legal/current  - public, unauthenticated (no envelope, `call.respond(...)` directly -
//                           same shape the public landing page's legalService.ts consumes).
//   GET  /legal/versions - requires a CORE staff JWT (checked via
//                           ApplicationCall.handleWithCoreDBNoTransaction), response wrapped in
//                           the standard `{ error, status_code, data }` envelope - same convention
//                           as e.g. DebugLogsService.js's `/debug/*` endpoints.
//   POST /legal/publish  - same auth/envelope as /legal/versions.
//
// Auth: no special handling needed here - axiosInstance (see utils/AxiosConfig.js) already
// attaches `Authorization: Bearer <accessToken>` from localStorage to every request via a global
// interceptor, same as every other admin/core service in this dashboard.

import axiosInstance from '../utils/AxiosConfig';

const LegalDocumentService = {
  async getCurrent() {
    const response = await axiosInstance.get('/legal/current');
    return response.data;
  },

  async getVersions() {
    const response = await axiosInstance.get('/legal/versions');
    return response.data?.data || [];
  },

  async publish(termsText, privacyText, dataDeletionText) {
    const response = await axiosInstance.post('/legal/publish', {
      termsText,
      privacyText,
      dataDeletionText,
    });
    return response.data?.data;
  },
};

export default LegalDocumentService;
